import { createTextVNode as _createTextVNode, createVNode as _createVNode } from "vue";
import { defineComponent, useCssModule } from "vue";
export default defineComponent({
  props: {
    // 内容型弹窗使用正常文档流占位；默认保留表格覆盖式布局。
    inline: {
      type: Boolean,
      default: false
    }
  },
  setup(props, ctx) {
    const css = useCssModule("css");
    return () => _createVNode("div", {
      "class": [css.empty, props.inline && css.inline]
    }, [_createVNode("img", {
      "class": css.img,
      "src": "http://yuou-server-test.oss-cn-hangzhou.aliyuncs.com/USER/2022/8/31/630efc45e4b0431cc69cd3eb.png"
    }, null), _createVNode("span", {
      "class": css.text
    }, [_createTextVNode("\u6682\u65E0\u6570\u636E")])]);
  }
});